(() => {
  const ymd = date => date.toISOString().slice(0, 10);
  function localClock(now, zone) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now);
    const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
    return { date: new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day))), hour: Number(p.hour) };
  }
  function deliveryRange({ now = new Date(), zone = 'America/Monterrey', min = 1, max = 3, cutoff = 14, saturday = false, holidays = [] } = {}) {
    const { date, hour } = localClock(now, zone);
    const excluded = new Set(holidays.map(s => s.trim()).filter(s => /^\d{4}-\d{2}-\d{2}$/.test(s)));
    const working = d => d.getUTCDay() !== 0 && (saturday || d.getUTCDay() !== 6) && !excluded.has(ymd(d));
    const next = d => { const out = new Date(d); out.setUTCDate(out.getUTCDate() + 1); return out; };
    let start = date;
    if (hour >= cutoff && working(start)) start = next(start);
    let guard = 0;
    while (!working(start) && guard++ < 730) start = next(start);
    const add = days => { let d = new Date(start), count = 0, iterations = 0; while (count < days && iterations++ < 730) { d = next(d); if (working(d)) count++; } return d; };
    const from = Math.max(0, Math.min(90, Number(min) || 0));
    const to = Math.max(from, Math.min(90, Number(max) || from));
    return { from: ymd(add(from)), to: ymd(add(to)) };
  }
  function rangeLabel(range) {
    const from = new Date(range.from + 'T12:00:00Z'), to = new Date(range.to + 'T12:00:00Z');
    const dayMonth = date => new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(date);
    if (range.from === range.to) return dayMonth(from);
    if (from.getUTCMonth() === to.getUTCMonth() && from.getUTCFullYear() === to.getUTCFullYear()) return from.getUTCDate() + '–' + dayMonth(to);
    const differentYear = from.getUTCFullYear() !== to.getUTCFullYear();
    return dayMonth(from) + (differentYear ? ' de ' + from.getUTCFullYear() : '') + ' – ' + dayMonth(to) + (differentYear ? ' de ' + to.getUTCFullYear() : '');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { deliveryRange, rangeLabel, localClock };
  if (typeof window === 'undefined' || !window.customElements) return;
  if (window.__mvpPdpLoaded) return; window.__mvpPdpLoaded = true;
  const route = path => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + path;
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  function syncAvailability(picker) {
    const root = picker.closest('mvp-product-page') || document;
    if (root.dataset?.mvpAvailableOnly === 'true') return;
    const ownSource = picker.querySelector('[data-mvp-availability]');
    const sharedSource = [...root.querySelectorAll('[data-mvp-product-availability]')].find(n => !picker.dataset.productId || n.dataset.productId === picker.dataset.productId);
    const source = ownSource || sharedSource;
    let data; try { if (source) data = JSON.parse(source.textContent); } catch (_) { /* Fall back to native flags. */ }
    const inputs = [...picker.querySelectorAll('input[type="radio"]')];
    const groups = [...new Set(inputs.map(input => input.name))];
    const position = input => {
      const nativePosition = Number(input.dataset.inputId?.split('-')[0]);
      return Number.isInteger(nativePosition) && nativePosition > 0 ? nativePosition - 1 : groups.indexOf(input.name);
    };
    const selected = Array.isArray(data?.selected) ? [...data.selected] : [];
    picker.querySelectorAll('input[type="radio"]:checked,select option:checked').forEach(input => {
      const pos = position(input); if (pos >= 0) selected[pos] = input.value;
    });
    inputs.forEach(input => {
      const pos = position(input), combination = [...selected]; combination[pos] = input.value;
      const knownCombination = Array.isArray(data?.variants) && selected.length > 0 && selected.every(value => typeof value === 'string');
      const available = knownCombination ? data.variants.some(v => v.available && v.options.every((value, i) => value === combination[i])) : input.dataset.optionAvailable !== 'false' && input.getAttribute('aria-disabled') !== 'true' && !input.disabled;
      const label = input.closest('.variant-option__button-label'); if (!label) return;
      if (label.dataset.mvpUnavailable !== String(!available)) label.dataset.mvpUnavailable = String(!available);
      if (!label.querySelector('.mp-variant-strike')) {
        const line = document.createElement('span'); line.className = 'mp-variant-strike'; line.setAttribute('aria-hidden', 'true'); label.append(line);
      }
    });
  }
  define('mvp-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return; this.abort = new AbortController();
      const refresh = () => this.querySelectorAll('variant-picker').forEach(syncAvailability);
      const queueRefresh = () => {
        if (this.availabilityRaf) return;
        this.availabilityRaf = requestAnimationFrame(() => { this.availabilityRaf = 0; if (this.isConnected) refresh(); });
      };
      this.addEventListener('change', event => { const picker = event.target.closest('variant-picker'); if (picker) { syncAvailability(picker); queueRefresh(); } }, { signal: this.abort.signal });
      this.availabilityObserver = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'attributes') {
            if (record.attributeName === 'data-mvp-unavailable' && record.target.hasAttribute('data-mvp-unavailable')) continue;
            if (record.target.closest('variant-picker')) { queueRefresh(); break; }
          } else {
            const changed = [...record.addedNodes, ...record.removedNodes];
            if (changed.length && changed.every(n => n.nodeType === 1 && n.matches('.mp-variant-strike'))) continue;
            if (record.target.closest('variant-picker,[data-mvp-product-availability]') || changed.some(n => n.nodeType === 1 && (n.matches('variant-picker,[data-mvp-product-availability]') || n.querySelector('variant-picker')))) { queueRefresh(); break; }
          }
        }
      });
      this.availabilityObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked','selected','aria-disabled','data-option-available','data-mvp-unavailable'] }); refresh();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-size-guide-link]'); if (!link) return;
        const guide = this.querySelector('details.mp-size-guide'); if (!guide) return;
        event.preventDefault(); guide.open = true; guide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.availabilityObserver?.disconnect(); cancelAnimationFrame(this.availabilityRaf); this.availabilityRaf = 0; }
  });
  // The native picker still owns price, gallery, URL and cart updates.
  // This wrapper filters choices and supplies a compatible selection before its change handler.
  define('mvp-stock-options', class extends HTMLElement {
    connectedCallback() {
      if (this.abort || this.dataset.enabled !== 'true') return;
      this.abort = new AbortController(); this.selectCache = new WeakMap();
      this.addEventListener('change', event => {
        const picker = event.target.closest('variant-picker');
        if (!picker || !this.contains(picker)) return;
        this.sync(picker, event.target, true, false);
      }, { capture: true, signal: this.abort.signal });
      this.observer = new MutationObserver(records => {
        if (records.some(record => {
          if (record.target.closest('variant-picker,[data-mvp-stock-data]')) return true;
          if (record.type !== 'childList') return false;
          return [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('variant-picker,[data-mvp-stock-data]') || node.querySelector('variant-picker')));
        })) this.schedule();
      });
      this.observer.observe(this, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked','selected','aria-disabled','data-option-available','data-product-id'] });
      this.refresh(false);
      customElements.whenDefined('variant-picker').then(() => {
        const ready = () => { if (this.isConnected && this.abort) { this.nativeReady = true; this.refresh(true); } };
        // Wait for the surrounding native product form to finish attaching its listeners.
        if (document.readyState === 'complete') ready();
        else window.addEventListener('load', ready, { once: true, signal: this.abort.signal });
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); cancelAnimationFrame(this.raf); this.raf = 0; }
    schedule() { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; if (this.isConnected) this.refresh(Boolean(this.nativeReady)); }); }
    refresh(repair) { this.querySelectorAll('variant-picker').forEach(picker => this.sync(picker, null, repair, true)); }
    groups(picker) {
      return [...picker.querySelectorAll('.variant-option')].map((element, index) => {
        const select = element.querySelector('select');
        let choices;
        if (select) {
          const live = [...select.options], cached = this.selectCache.get(select);
          if (!cached || live.some(node => !cached.all.includes(node) || cached.keys.get(node) !== node.value + '|' + node.dataset.optionValueId)) {
            this.selectCache.set(select, { all: live, keys: new Map(live.map(node => [node, node.value + '|' + node.dataset.optionValueId])) });
          }
          choices = this.selectCache.get(select).all;
        } else choices = [...element.querySelectorAll('input[type="radio"]')];
        const first = choices[0], position = Number(first?.dataset.inputId?.split('-')[0]);
        return { element, select, choices, index: Number.isInteger(position) && position > 0 ? position - 1 : index };
      }).sort((a, b) => a.index - b.index);
    }
    data(picker, groups) {
      const differentProduct = groups.some(group => group.choices.some(choice => choice.dataset.connectedProductUrl && new URL(choice.dataset.connectedProductUrl, location.href).pathname !== new URL(picker.dataset.productUrl || location.href, location.href).pathname));
      if (differentProduct) return null;
      const source = [...this.querySelectorAll('[data-mvp-stock-data]')].find(node => !picker.dataset.productId || node.dataset.productId === picker.dataset.productId);
      try { const data = JSON.parse(source?.textContent || 'null'); return Array.isArray(data?.variants) ? data : null; } catch (_) { return null; }
    }
    nativeAvailable(choice) {
      const unavailable = this.closest('mvp-product-page')?.dataset.mvpUnavailableLabel;
      return choice.dataset.optionAvailable !== 'false' && choice.getAttribute('aria-disabled') !== 'true' && !choice.disabled && !(choice.tagName === 'OPTION' && unavailable && choice.textContent.trim().endsWith(' - ' + unavailable));
    }
    setHidden(node, hide) {
      if (node.dataset.mvpStockHidden !== String(hide)) node.dataset.mvpStockHidden = String(hide);
      if (node.hidden !== hide) node.hidden = hide;
    }
    sync(picker, changed, repair, notify) {
      const groups = this.groups(picker); if (!groups.length) return;
      const data = this.data(picker, groups), available = data?.variants.filter(variant => variant.available);
      const selected = [...(data?.selected || [])];
      groups.forEach(group => {
        const chosen = group.select ? group.select.selectedOptions[0] : group.choices.find(choice => choice.checked);
        if (chosen) selected[group.index] = chosen.value;
      });
      let repaired = false, dispatchControl;
      if (available?.length && repair) {
        const changedGroup = groups.find(group => group.select === changed || group.choices.includes(changed));
        const end = changedGroup ? changedGroup.index : -1;
        const candidates = available.filter(variant => variant.options.every((value, i) => i > end || value === selected[i]));
        const exact = available.find(variant => variant.options.every((value, i) => value === selected[i]));
        const best = exact || (candidates.length ? candidates : available).reduce((best, variant) => {
          const score = variant.options.reduce((sum, value, i) => sum + Number(value === selected[i]), 0);
          return !best || score > best.score ? { variant, score } : best;
        }, null)?.variant;
        if (best) {
          groups.forEach(group => {
            const choice = group.choices.find(node => node.value === best.options[group.index]);
            if (!choice) return;
            const current = group.select ? group.select.value : group.choices.find(node => node.checked)?.value;
            if (group.select && !choice.isConnected) group.select.append(choice);
            if (current !== choice.value) {
              if (group.select) group.select.value = choice.value;
              else choice.checked = true;
              if (typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(group.select || choice);
              else if (group.select) group.choices.forEach(node => node.toggleAttribute('selected', node === choice));
              repaired = true; dispatchControl ||= group.select || choice;
            }
            selected[group.index] = choice.value;
          });
          const target = changed?.tagName === 'SELECT' ? changed.selectedOptions[0] : changed;
          if (target && best.id) target.dataset.variantId = String(best.id);
          if (dispatchControl) {
            const target = dispatchControl.tagName === 'SELECT' ? dispatchControl.selectedOptions[0] : dispatchControl;
            if (target && best.id) target.dataset.variantId = String(best.id);
          }
        }
      }
      groups.forEach(group => {
        const visible = [];
        group.choices.forEach(choice => {
          const inStock = data ? available.some(variant => variant.options[group.index] === choice.value && variant.options.every((value, i) => i >= group.index || selected[i] === undefined || value === selected[i])) : this.nativeAvailable(choice);
          if (inStock) visible.push(choice);
          if (!group.select) this.setHidden(choice.closest('.variant-option__button-label') || choice.parentElement, !inStock);
        });
        if (group.select) {
          // Removing sold-out <option> nodes also works in native mobile select menus.
          // Retain their original nodes so changing an earlier option can restore them.
          const live = [...group.select.options];
          if (live.length !== visible.length || live.some((node, i) => node !== visible[i])) {
            const value = group.select.value;
            group.select.replaceChildren(...visible);
            if (visible.some(choice => choice.value === value)) group.select.value = value;
          }
        }
        const singleAvailable = data ? available.some(variant => variant.options.every((value, i) => i > group.index || selected[i] === undefined || value === selected[i])) : true;
        this.setHidden(group.element, group.choices.length ? visible.length === 0 : !singleAvailable);
      });
      if (notify && repaired && dispatchControl) dispatchControl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  define('mvp-delivery', class extends HTMLElement {
    connectedCallback() { this.update(); this.timer = setInterval(() => this.update(), 60000); }
    update() {
      try {
        const holidays = JSON.parse(this.querySelector('[data-holidays]').textContent).split(/[\n,]+/);
        const range = deliveryRange({ zone: this.dataset.zone, min: this.dataset.min, max: this.dataset.max, cutoff: Number(this.dataset.cutoff), saturday: this.dataset.saturday === 'true', holidays });
        const result = this.querySelector('[data-delivery-result]');
        result.textContent = (this.dataset.dateLabel || '') + ' ' + rangeLabel(range);
        result.dataset.from = range.from; result.dataset.to = range.to;
      } catch (_) { /* Retain the merchant's fallback text if configuration is incomplete. */ }
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
  let cartEvents;
  const events = () => cartEvents ||= import('@shopify/events').catch(() => null);
  async function addToCart(source, variant) {
    let modern, deferred, confirmed = false;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n => n.dataset.sectionId))].slice(0, 5);
    try {
      try {
        modern = (await events())?.CartLinesUpdateEvent;
        if (modern?.createPromise) { deferred = modern.createPromise(); source.dispatchEvent(new modern({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variant.id), quantity: 1 }], promise: deferred.promise })); }
      } catch (_) { modern = null; deferred = null; }
      const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: String(variant.id), quantity: 1 }], ...(sections.length ? { sections, sections_url: location.pathname } : {}) }) });
      const result = await response.json();
      if (!response.ok || result.status) throw Object.assign(new Error(typeof result.description === 'string' ? result.description : 'No se pudo agregar. Revisa la disponibilidad.'), { rejected: true });
      confirmed = true;
      const cart = await fetch(route('cart.js'), { cache: 'no-store', headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null);
      const detail = { source: 'mvp-pdp-extra', sourceId: source.id, itemCount: 1, items: cart?.items || result.items, sections: result.sections, didError: false };
      if (deferred) { deferred.resolve({ ...(cart && modern.createCartFromAjaxResponse ? { cart: modern.createCartFromAjaxResponse(cart) } : {}), detail }); deferred = null; }
      else source.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: result, sourceId: 'mvp-pdp-extra', data: detail } }));
      if (cart) document.querySelectorAll('[data-mvp-cart-count]').forEach(n => { n.textContent = String(cart.item_count); });
      document.dispatchEvent(new CustomEvent('mvp:cart:add', { detail: { ...result, cart } }));
      return result;
    } catch (error) {
      deferred?.resolve({ detail: { didError: true } });
      if (confirmed) return { confirmed: true };
      throw error;
    }
  }
  define('mvp-product-extra', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      const form = this.querySelector('[data-extra-form]'); if (!form) return;
      try { this.variants = JSON.parse(this.querySelector('[data-extra-data]').textContent); } catch (_) { return; }
      this.abort = new AbortController(); this.id ||= 'MvpExtra-' + Math.random().toString(36).slice(2);
      this.form = form; this.select = this.querySelector('[data-extra-variant]'); this.button = this.querySelector('[data-extra-submit]'); this.status = this.querySelector('[data-extra-status]'); this.cart = this.querySelector('[data-extra-cart]');
      this.select.addEventListener('change', () => this.update(), { signal: this.abort.signal });
      form.addEventListener('submit', event => { event.preventDefault(); if (form.reportValidity()) this.add(); }, { signal: this.abort.signal });
      this.update();
    }
    update() {
      const variant = this.variants.find(v => String(v.id) === this.select.value);
      this.current = variant; this.button.disabled = !variant?.available || Boolean(this.pending);
      // Preview the same variant rendered by Liquid without selecting it for purchase.
      const displayed = variant || this.variants.find(v => String(v.id) === this.dataset.initialVariant);
      if (displayed) {
        this.querySelector('[data-extra-price]').textContent = displayed.money;
        const compare = this.querySelector('[data-extra-compare]'), discount = this.querySelector('[data-extra-discount]');
        const reduced = displayed.compare > displayed.price;
        compare.hidden = discount.hidden = !reduced;
        compare.textContent = reduced ? displayed.compareMoney : ''; discount.textContent = reduced ? '−' + Math.round((1 - displayed.price / displayed.compare) * 100) + '%' : '';
      }
    }
    async add() {
      const v = this.current; if (this.pending || !v?.available) return;
      if (v.min > 1 || v.increment > 1) { const target = new URL(this.dataset.productUrl, location.href); target.searchParams.set('variant', String(v.id)); location.assign(target.href); return; }
      this.pending = true; this.button.disabled = this.select.disabled = true; this.setAttribute('aria-busy', 'true'); this.status.textContent = 'Agregando…'; this.cart.hidden = true;
      try { await addToCart(this, v); this.status.textContent = 'Agregado a tu bolsa.'; this.cart.hidden = false; }
      catch (error) { this.status.textContent = error.rejected ? error.message : 'No pudimos confirmar si se añadió. Revisa tu bolsa antes de volver a intentar.'; this.cart.hidden = Boolean(error.rejected); }
      finally { this.pending = false; this.select.disabled = false; this.removeAttribute('aria-busy'); this.update(); }
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
  define('mvp-review-loop', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.viewport = this.querySelector('[data-review-viewport]'); this.track = this.querySelector('[data-review-track]');
      if (!this.viewport || !this.track) return;
      this.abort = new AbortController(); const signal = this.abort.signal;
      this.editor = this.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
      this.dialog = this.querySelector('[data-review-dialog]'); this.player = this.querySelector('[data-review-player]'); this.pauseButton = this.querySelector('[data-review-pause]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = !this.editor && this.dataset.autoplay === 'true' && !this.reduced.matches;
      this.inside = false; this.hovered = false; this.focused = false; this.holdUntil = 0; this.span = 0; this.base = 0; this.copiesPerSide = 0;
      this.refreshCards(); this.scheduleMeasure(true);
      this.observer = new ResizeObserver(() => this.scheduleMeasure()); this.observer.observe(this.viewport);
      this.mutations = new MutationObserver(records => {
        // Our visual copies are not merchant blocks and never trigger a rebuild.
        if (records.some(r => [...r.addedNodes, ...r.removedNodes].some(n => n.nodeType === 1 && n.matches('.mp-review:not([data-review-copy])')))) {
          this.refreshCards(); this.scheduleMeasure(true);
        }
      }); this.mutations.observe(this.track, { childList: true });
      this.track.addEventListener('load', () => this.scheduleMeasure(), { signal, capture: true });
      this.intersection = new IntersectionObserver(entries => {
        this.inside = entries[0].isIntersecting;
        if (this.inside) { this.scheduleMeasure(); this.startAnimation(); } else this.stopAnimation();
      }); this.intersection.observe(this);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.stopAnimation(); }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.startAnimation(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.stopAnimation(); }, { signal });
      this.addEventListener('focusout', () => { queueMicrotask(() => { if (!this.isConnected) return; this.focused = this.contains(document.activeElement); this.startAnimation(); }); }, { signal });
      const hold = () => { this.holdUntil = performance.now() + 8000; };
      this.viewport.addEventListener('pointerdown', hold, { signal }); this.viewport.addEventListener('wheel', hold, { signal, passive: true });
      this.viewport.addEventListener('scroll', () => this.normalize(), { signal, passive: true });
      this.querySelector('[data-review-next]')?.addEventListener('click', () => this.step(1), { signal });
      this.querySelector('[data-review-prev]')?.addEventListener('click', () => this.step(-1), { signal });
      this.pauseButton?.addEventListener('click', () => { this.running = !this.running; this.setPauseLabel(); this.running ? this.startAnimation() : this.stopAnimation(); }, { signal });
      if (this.pauseButton) this.pauseButton.hidden = this.editor;
      this.setPauseLabel();
      this.addEventListener('shopify:block:select', event => {
        if (!this.editor) return;
        const card = event.target.closest('.mp-review');
        if (card && this.track.contains(card)) this.viewport.scrollLeft = card.offsetLeft - this.originals[0].offsetLeft;
      }, { signal });
      this.addEventListener('click', event => {
        const read = event.target.closest('[data-review-read]');
        if (read) {
          const content = read.closest('.mp-review').querySelector('.mp-review__body').cloneNode(true);
          content.querySelectorAll('button').forEach(n => n.remove());
          content.querySelectorAll('p').forEach(n => { n.style.display = 'block'; n.style.webkitLineClamp = 'unset'; });
          this.dialog.classList.add('mp-review-dialog--text'); this.player.replaceChildren(content); this.dialog.showModal(); this.stopAnimation(); return;
        }
        const button = event.target.closest('[data-review-play]'); if (!button) return;
        const originalVideo = button.closest('.mp-review').querySelector('video'); if (!originalVideo) return;
        this.dialog.classList.remove('mp-review-dialog--text');
        const video = originalVideo.cloneNode(true); video.controls = true; video.muted = false; video.autoplay = false; video.removeAttribute('loop');
        this.player.replaceChildren(video); this.dialog.showModal(); this.stopAnimation(); video.play().catch(() => {});
      }, { signal });
      const close = () => { this.player.querySelector('video')?.pause(); this.player.replaceChildren(); this.startAnimation(); };
      this.querySelector('[data-review-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('close', close, { signal }); this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.motionChange = () => { if (this.reduced.matches) this.running = false; this.setPauseLabel(); this.scheduleMeasure(true); this.running ? this.startAnimation() : this.stopAnimation(); };
      this.reduced.addEventListener('change', this.motionChange);
      document.addEventListener('visibilitychange', () => document.hidden ? this.stopAnimation() : this.startAnimation(), { signal });
    }
    refreshCards() {
      this.originals = [...this.track.children].filter(n => n.matches('.mp-review:not([data-review-copy])'));
      this.querySelector('.mp-reviews__controls').hidden = this.originals.length < 2;
    }
    scheduleMeasure(reset = false) {
      this.needsReset ||= reset;
      if (this.measureRaf) return;
      this.measureRaf = requestAnimationFrame(() => {
        this.measureRaf = 0; if (!this.isConnected) return;
        const shouldReset = this.needsReset; this.needsReset = false; this.measure(shouldReset);
      });
    }
    measure(reset = false) {
      const cards = this.originals, width = this.viewport.clientWidth;
      cards.forEach(card => { const p = card.querySelector('[data-review-text]'), b = card.querySelector('[data-review-read]'); if (b && p) b.hidden = p.scrollHeight <= p.clientHeight + 1; });
      // Hidden editor previews can report zero-sized cards. Never divide by that or recurse.
      const cardWidth = cards[0]?.getBoundingClientRect().width || 0;
      if (width <= 0 || cardWidth <= 0 || cards.length < 2 || this.editor || this.reduced.matches) {
        this.removeCopies(); this.span = 0; this.base = 0; return;
      }
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const span = cards.reduce((sum, n) => sum + n.getBoundingClientRect().width + gap, 0);
      if (!Number.isFinite(span) || span < 1) return;
      const copies = Math.min(4, Math.max(1, Math.ceil(width / span) + 1));
      if (reset || copies !== this.copiesPerSide) {
        this.removeCopies();
        const clone = original => {
          const copy = original.cloneNode(true); copy.setAttribute('data-review-copy', ''); copy.setAttribute('aria-hidden', 'true');
          [copy, ...copy.querySelectorAll('*')].forEach(n => {
            n.removeAttribute('id');
            [...n.attributes].filter(a => a.name.startsWith('data-shopify')).forEach(a => n.removeAttribute(a.name));
          });
          copy.querySelectorAll('a,button,video,[tabindex]').forEach(n => { n.tabIndex = -1; });
          copy.querySelectorAll('video').forEach(n => { n.preload = 'none'; n.removeAttribute('autoplay'); });
          return copy;
        };
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        for (let n = 0; n < copies; n++) cards.forEach(o => { before.append(clone(o)); after.append(clone(o)); });
        this.track.prepend(before); this.track.append(after); this.copiesPerSide = copies;
        this.span = span; this.base = copies * span; this.viewport.scrollLeft = this.base;
      } else { this.span = span; this.base = copies * span; this.normalize(); }
      this.startAnimation();
    }
    removeCopies() { this.track.querySelectorAll('[data-review-copy]').forEach(n => n.remove()); this.copiesPerSide = 0; }
    normalize() {
      if (!this.span || this.editor || this.normalizing) return;
      const left = this.viewport.scrollLeft;
      if (left >= this.base && left < this.base + this.span) return;
      this.normalizing = true;
      this.viewport.scrollLeft = this.base + ((left - this.base) % this.span + this.span) % this.span;
      this.normalizing = false;
    }
    canAnimate() { return this.running && !this.editor && !this.reduced.matches && this.inside && !this.hovered && !this.focused && !document.hidden && !this.dialog?.open && this.span > 0; }
    startAnimation() {
      if (this.raf || !this.canAnimate()) return;
      this.lastTime = 0;
      const tick = time => {
        this.raf = 0; if (!this.canAnimate()) return;
        const delta = Math.min(40, time - (this.lastTime || time)); this.lastTime = time;
        if (time > this.holdUntil) { this.fraction = (this.fraction || 0) + (Number(this.dataset.speed) || 16) * delta / 1000; const pixels = Math.trunc(this.fraction); if (pixels) { this.viewport.scrollLeft += pixels; this.fraction -= pixels; this.normalize(); } }
        this.raf = requestAnimationFrame(tick);
      }; this.raf = requestAnimationFrame(tick);
    }
    stopAnimation() { cancelAnimationFrame(this.raf); this.raf = 0; this.lastTime = 0; }
    step(direction) {
      this.holdUntil = performance.now() + 8000;
      this.viewport.scrollBy({ left: direction * ((this.originals[0]?.getBoundingClientRect().width || 220) + (parseFloat(getComputedStyle(this.track).columnGap) || 12)), behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    setPauseLabel() { if (!this.pauseButton) return; this.pauseButton.textContent = this.running ? 'Ⅱ' : '▶'; this.pauseButton.setAttribute('aria-label', this.running ? this.pauseButton.dataset.pauseLabel : this.pauseButton.dataset.playLabel); }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.stopAnimation(); cancelAnimationFrame(this.measureRaf); this.measureRaf = 0;
      this.observer?.disconnect(); this.mutations?.disconnect(); this.intersection?.disconnect(); this.reduced?.removeEventListener('change', this.motionChange);
      this.removeCopies(); this.player?.querySelector('video')?.pause(); this.player?.replaceChildren();
      this.needsReset = false;
    }
  });
})();
